<template>
  <div class="home-page">
    <!-- Navbar -->
    <navbar-home></navbar-home>
    <section class="ew-smaller-container ew-bigger-line-height mb-5">
      <h3 class="ew-section-header">Términos y Condiciones</h3>
      <p>El usuario se adhiere y se obliga a los términos y condiciones expuestos a continuación. En caso de que existan
        restricciones adicionales por parte de terceros, estas se aplicarán además de las mencionadas aquí. La
        información del sitio puede sufrir modificaciones sin previo aviso.</p>

      <p class="h4 text-primary font-weight-bold alt-font">(Cláusulas)</p>
      <h4 class="text-primary font-weight-bold alt-font">PRIMERA.</h4>
      <p>Al acceder y navegar por este sitio, el usuario acepta sujetarse a los presentes términos y condiciones sin
        limitación, incluyendo actualizaciones o modificaciones. Algunos servicios pueden tener términos adicionales que
        podrán consultarse en sus respectivos enlaces.</p>
      <p>Se reservan derechos de llevar a cabo acciones legales en caso de violación a estos términos, incluyendo
        restringir el acceso a determinados usuarios. Todos los cambios entrarán en vigor al momento de su publicación,
        y los usuarios podrán optar por no aceptar dichas modificaciones eliminando su cuenta.</p>

      <h4 class="text-primary font-weight-bold alt-font">SEGUNDA.</h4>
      <p>Contenido del sitio</p>
      <ol class="ew-list-latin-styles">
        <li>El sitio proporciona información sobre medios de transporte disponibles para envíos, para que el usuario
          pueda elegir libremente.</li>
        <li>Los tiempos de entrega y recolección son responsabilidad de la compañía transportista seleccionada.</li>
      </ol>

      <h4 class="text-primary font-weight-bold alt-font">TERCERA.</h4>
      <p>Obligaciones del Usuario (remitente).</p>
      <ol class="ew-list-latin-styles">
        <li>Proporcionar con veracidad los datos del paquete, incluyendo tamaño, peso, contenido y datos del
          destinatario.</li>
        <li>Realizar el pago correspondiente por el envío, impuestos, gastos aduanales y cualquier otro cargo derivado
          del envío.</li>
        <li>Declarar contar con la legal posesión de los artículos a enviar y la capacidad legal para aceptar este
          contrato.</li>
        <li>Eximir de responsabilidad al sitio por el contenido del envío y pagar daños y perjuicios derivados de
          posibles responsabilidades.</li>
        <li>El embalaje del paquete será responsabilidad del usuario.</li>
      </ol>

      <h4 class="text-primary font-weight-bold alt-font">CUARTA.</h4>
      <p>No se asume responsabilidad sobre la exactitud de información de terceros publicada en el sitio. El usuario es
        responsable de evaluar la utilidad de la información y, en caso necesario, consultar con un especialista.</p>

      <h4 class="text-primary font-weight-bold alt-font">QUINTA.</h4>
      <p>No se asume responsabilidad por daños directos o indirectos derivados del acceso o uso del sitio, incluyendo
        virus o software malicioso.</p>

      <h4 class="text-primary font-weight-bold alt-font">SEXTA.</h4>
      <p>Se hará lo posible por mantener la confidencialidad de la información personal de los usuarios, salvo por lo
        establecido legalmente.</p>

      <h4 class="text-primary font-weight-bold alt-font">SÉPTIMA.</h4>
      <p>Queda prohibida la vinculación o enmarcación no autorizada de este sitio. El acceso a sitios vinculados será
        bajo riesgo del usuario.</p>

      <h4 class="text-primary font-weight-bold alt-font">OCTAVA.</h4>
      <p>No se aceptan envíos de artículos, sustancias o materiales prohibidos por la ley o que representen un riesgo o
        amenaza.</p>

      <h4 class="text-primary font-weight-bold alt-font">NOVENA.</h4>
      <p>El usuario deberá realizar pagos mediante los métodos habilitados en el sitio.</p>

      <h4 class="text-primary font-weight-bold alt-font">DÉCIMA.</h4>
      <p>En caso de pérdida, daño o retraso del envío, el usuario deberá realizar reclamaciones directamente con la
        empresa transportista correspondiente.</p>

      <h4 class="text-primary font-weight-bold alt-font">DÉCIMA PRIMERA.</h4>
      <p>El usuario exime al sitio de responsabilidad por pérdida, daño, mala entrega o entrega demorada de los envíos,
        por causas fuera de su control o por uso incorrecto del embalaje.</p>

      <h4 class="text-primary font-weight-bold alt-font">DÉCIMA SEGUNDA.</h4>
      <p>Los datos personales se tratarán de acuerdo a la ley de protección de datos aplicable, garantizando
        confidencialidad y seguridad.</p>

      <h4 class="text-primary font-weight-bold alt-font">DÉCIMA TERCERA.</h4>
      <p>Se prohíbe interferir con el sitio mediante dispositivos, software u otros medios que puedan afectar sus
        operaciones o datos.</p>

      <h4 class="text-primary font-weight-bold alt-font">DÉCIMA CUARTA.</h4>
      <p>Este acuerdo no crea contratos de sociedad, franquicia, mandato o relación laboral entre los usuarios y el
        sitio.</p>

      <h4 class="text-primary font-weight-bold alt-font">DÉCIMA QUINTA.</h4>
      <p>El sitio no garantiza disponibilidad continua ni se responsabiliza por problemas técnicos, fallas de sistema o
        virus en los equipos de los usuarios.</p>

      <h4 class="text-primary font-weight-bold alt-font">DÉCIMA SEXTA.</h4>
      <p>Para interpretación de este contrato, las partes se someten a la jurisdicción y leyes locales correspondientes.
      </p>

    </section>
    <!-- Footer global -->
    <AppFooter />
  </div>
</template>


<script>
import AppFooter from "@/components/AppFooter.vue";
import NavbarHome from "@/components/Header/NavbarHome.vue";

export default {
  name: 'TermsAndConditions',
  data() {
    return {}
  },
  watch: {},
  methods: {
  },
  computed: {},
  created() { },
  components: {
    AppFooter,
    "navbar-home": NavbarHome
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
p,
ol li,
ul li {
  text-align: justify;
}

.ew-loading-indicator {
  min-height: 100vh;
  background-color: #ededed;

  .inner-container {
    min-height: 100vh;
    background-color: white;
    min-width: 80%;
    max-width: 1340px;
    margin: 0 auto;
  }
}

.ew-icon {
  width: 1.3rem;
  height: 1.3rem;
}

.ew-card-services {
  position: absolute;
  width: 100px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

.flotante-wa {
  bottom: 7rem !important;
}

.flotante {
  display: scroll;
  position: fixed;
  bottom: 2rem;
  left: 1.5rem;
  color: #fff;
  background: #0057ba;
  border-radius: 50%;
  border: 0 none;
  -webkit-box-shadow: 0 4px 5px -1px rgba(0, 0, 0, 0.5);
  -moz-box-shadow: 0 4px 5px -1px rgba(0, 0, 0, 0.5);
  box-shadow: 0 4px 5px -1px rgba(0, 0, 0, 0.5);
  width: 65px;
  height: 65px;
  text-align: center;
  line-height: 65px;
}

@media (max-width: 767px) {
  .flotante-wa {
    bottom: 6.2rem;
  }

  .flotante {
    bottom: 1.2rem;
    left: 1.4rem;
    width: 48px;
    height: 48px;
    line-height: 48px;
  }

  .flotante img {
    width: 22px;
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TermsAndConditions.vue